import posthog from 'posthog-js';

import { config } from '~/config';

const isDevOrLocalEnvironment = () =>
  config.app.isLocalEnvironment ||
  ['dev', 'local'].includes(config.app.environment);

const shouldEnableTracking = () =>
  ['staging', 'prod'].includes(config.app.environment);

const captureException = (
  exception: Error | unknown,
  context?: Record<string, string>
) => {
  if (isDevOrLocalEnvironment()) {
    console.error('[Tracking]', exception, context);
    return;
  }

  // eslint-disable-next-line no-console
  console.error({
    Logger: exception,
    context,
  });

  if (shouldEnableTracking()) {
    posthog.captureException(exception, context);
  }
};

const captureMessage = (message: string, level?: string) => {
  if (isDevOrLocalEnvironment()) {
    console.error('[Tracking]', message, level);
    return;
  }

  // eslint-disable-next-line no-console
  console.error({ Logger: message, level });

  if (shouldEnableTracking()) {
    posthog.captureException(new Error(message), {
      $exception_level: level ?? 'error',
    });
  }
};

export const Tracking = {
  captureException,
  captureMessage,
};
